import React from "react";
import { Button } from "../ui/button";
import noCourseImage from "@/assets/nocourse_image.svg";
import { Play } from "lucide-react";

export default function ContinueLearningCard({ course, onContinue }) {
  const topicsCompleted = course.topicsCompleted ?? 0;
  const totalTopics = course.totalTopics ?? 100;
  const progressPercent = Math.min(
    Math.max((topicsCompleted / totalTopics) * 100, 0),
    100
  );
  return (
    <div className="flex w-[30rem] h-[11rem] font-sans my-2 rounded-2xl shadow-md overflow-hidden bg-white relative mr-4">
      {/* Left Image Section */}
      <div className="w-2/5 flex items-center justify-center bg-gray-100">
        <img
          src={course.image || noCourseImage}
          alt={course.title}
          className="w-full h-full object-cover object-center"
        />
      </div>

      {/* Right Info Section */}
      <div className="w-3/5 flex flex-col justify-between px-5 py-4">
        {/* Course Title & Topic */}
        <div>
          <div
            title={course.title}
            className="text-[17px] font-bold text-[#2d235a] line-clamp-2"
          >
            {course.title}
          </div>
          <div
            title={course.topicName}
            className="text-sm font-medium text-[#6b7280] line-clamp-1 mt-1"
          >
            {course.topicName}
          </div>
          {course.materialTitle && (
            <div
              title={course.topicName}
              className="text-sm font-medium text-[#6b7280] line-clamp-1 mt-1"
            >
              {course.materialTitle}
            </div>
          )}
        </div>

        {/* Progress + Button */}
        <div className="flex items-center justify-between mt-2">
          <div className="flex flex-col w-full pr-4">
            <div className="flex justify-between text-xs text-[#888] font-medium px-1 mb-1">
              <span>Progress</span>
              <span>
                {course.materialTitle
                  ? `${Math.round(progressPercent)}%`
                  : `${topicsCompleted}/${totalTopics} Topics`}
              </span>
            </div>
            <div className="w-full h-1.5 bg-[#ede9fe] rounded-full relative">
              <div
                className="absolute left-0 top-0 h-1.5 rounded-full bg-[var(--primary-font)] transition-all"
                style={{ width: `${progressPercent}%` }}
              ></div>
            </div>
          </div>

          <Button
            variant="default"
            className="shrink-0 w-12 h-12 px-4 py-2 rounded-full bg-[#5D93A5]  text-white !text-xs font-bold shadow hover:bg-[var(--secondary-font)] transition-colors flex items-center gap-2"
            onClick={() => onContinue(course)}
            aria-label={`Continue learning ${course.title}`}
          >
            <Play className="w-5 h-5 text-white fill-white" />
          </Button>
        </div>
      </div>
    </div>
  );
}
